import { render, staticRenderFns } from "./QueryProduct.vue?vue&type=template&id=dfaf9ec8"
import script from "./QueryProduct.vue?vue&type=script&lang=js"
export * from "./QueryProduct.vue?vue&type=script&lang=js"
import style0 from "./QueryProduct.vue?vue&type=style&index=0&id=dfaf9ec8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports